import { QUERY_INSIGHTS_API } from "admin/types/constants/queryInsights";
import type { ClassificationSummary } from "admin/types/interfaces/queryInsights";
import { useFetcher } from "~/hooks/useFetcher";

interface UseQueryInsightsParams {
  // Narrow every figure to these originating apps (each must be an app the
  // dashboard covers). Omit to aggregate all covered apps.
  appIds?: string[];
}

function buildUrl({ appIds }: UseQueryInsightsParams): string {
  const params = new URLSearchParams();
  appIds?.forEach((id) => params.append("app_ids", id));
  const queryString = params.toString();
  return `${QUERY_INSIGHTS_API}/summary${queryString ? `?${queryString}` : ""}`;
}

const useQueryInsights = ({ appIds }: UseQueryInsightsParams = {}) => {
  const url = buildUrl({ appIds });

  const { data, error, isLoading } = useFetcher<ClassificationSummary>(url, {
    shouldCamelize: true,
    keepPreviousData: true,
  });

  return {
    summary: data,
    error,
    isLoading,
    key: url, // resolved SWR key so callers can revalidate
  };
};

export default useQueryInsights;
